import { useMutateEntry, makeInitialOpgavekompleksetTaskEntry } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { updateStats } from './util.update-stats.js';

function useUpdateInputMutation() {
  const {
    entryKey,
    data
  } = useOpgavekompleksetComponent();
  const mutater = useMutateEntry(entryKey);
  return (taskId, inputId, value) => mutater(entry => {
    const taskEntry = entry.data.tasks[taskId] ??= makeInitialOpgavekompleksetTaskEntry(data, taskId);
    taskEntry.details[inputId] = typeof value === "function" ? value(taskEntry.details[inputId]) : value;
    updateStats(entry, data, taskId);
    taskEntry.state.validated = false;
    taskEntry.state.skipped = false;
    return entry;
  });
}

export { useUpdateInputMutation };
//# sourceMappingURL=update-input.js.map
